import { render } from "./Questions.vue?vue&type=template&id=1f708515&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"

import "./Questions.vue?vue&type=style&index=0&id=1f708515&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f708515"]])

export default __exports__